'use client';

import { useEffect } from 'react';

import { onEvent } from '@/events';

export function BrandKitPageViewedTracker(): null {
  useEffect(() => {
    onEvent('page_viewed', { path: '/brand', referrer: document.referrer });
  }, []);

  return null;
}
